import axios from 'axios'
import {Loading, Message, MessageBox} from 'element-ui'
import store from '../store'
import {getToken} from '@/utils/auth'
import JSEncrypt from "jsencrypt";
import {saveAs} from 'file-saver'
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})
let encrypt = new JSEncrypt();
// console.log(encrypt)
encrypt.setPublicKey(
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCtP1MKTZj5Hx1hxG3VgGpC5e/O21uHMjSvRYOjmhNuc+VaN8Hr29+gnbLA89O3IGIAcmj9aqkXK1zoxsNAjRXb32B92+/2/rkhNN2IK2pBgyTgQO1Hb66BifzIOEjK8/rSpcueZ19CJY0Rh0GesDBhVZJ1FpLF9O5+kEyAe3Q9FwIDAQAB"
);
// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers = {
      Xs_token: getToken(),
      sign: encrypt.encrypt(
        JSON.stringify({
          timeStamp: new Date().getTime(),
          requestId: Math.floor(100000000 + Math.random() * 900000000),
        })
      ),
    }
    // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data
    if (res.code !== 200 && res.code !== 20000) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })

      // 401:未登录;
      if (res.code === 401) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
        })
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

function blobValidate(data) {
  return data.type !== 'application/json'
}

const errorCode = {
  '401': '认证失败，无法访问系统资源',
  '403': '当前操作没有权限',
  '404': '访问资源不存在',
  'default': '系统未知错误，请反馈给管理员'
}
let downloadLoadingInstance
export function download(url, data, filename) {
  downloadLoadingInstance = Loading.service({
    text: "正在下载数据，请稍候",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  })
  return axios({

    headers: {
      Xs_token: getToken(),
      sign: encrypt.encrypt(
        JSON.stringify({
          timeStamp: new Date().getTime(),
          requestId: Math.floor(100000000 + Math.random() * 900000000),
        })
      ),
    },

    url: process.env.BASE_API + '/mall-admin/order/export',
    method: "post",
    data,
    responseType: 'blob'


  }).then(res => {
    const data = res.data
    const isBlob = blobValidate(data)
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = data.text()
      const rspObj = JSON.parse(resText)
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg)
    }
    downloadLoadingInstance.close()
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close()
  })
}


export default service



// WEBPACK FOOTER //
// ./src/utils/request.js